﻿import { SaopServicesCore } from "../Core/saop-services-core";


export class SaopPdfPreview {
    private _pdfjsLib:any;
    private _canvas:any;
    private _viewer:any;
    private _pdf:any;
    private _scale = 1;
    //
    private _documentId:string;
    private _url:string;
    private _fileName:string;
    private _base64:string;
    private _type:string;

    loadpdfjsLib(pdfjsLib:any):void{
        this._pdfjsLib = pdfjsLib;
    }

    renderPage(pageNumber:any, canvas:any):void {
        let _this = this;
        this._pdf.getPage(pageNumber).then(function(page:any) {
        _this._viewer = page.getViewport({ scale: _this._scale });

        //   let _viewerOffset = $('.pdf-viewer-inner').offset();
        //   let _w = Math.max(document.documentElement.clientWidth - _viewerOffset.left, window.innerWidth - _viewerOffset.left -272 || 0)

        // let _w = $('#pdf-viewer').width();
        // canvas.height = _this._viewer.height;
        // canvas.width = _w - 10;
        let _w = (_this._viewer.width as string)+'px'
        $('.saop-col-view').css('min-width', _w);

        canvas.height = _this._viewer.height - 10;
        canvas.width = _this._viewer.width - 10;          
        page.render({canvasContext: canvas.getContext('2d'), viewport: _this._viewer});
    });
    }    

    base64ToUint8Array(base64:string):any{
        var raw = atob(base64);
        var uint8Array = new Uint8Array(raw.length);
        for (var i = 0; i < raw.length; i++) {
            uint8Array[i] = raw.charCodeAt(i);
        }
        return uint8Array;
    }   

    loadingPdfTask(loadingTask:any):void{
        let _this = this;
        loadingTask.promise.then(function(pdf:any) {
            _this._pdf = pdf;
            _this._viewer = document.getElementById('pdf-viewer');
           
            for(let page = 1; page <= pdf.numPages; page++) {
                
 
              _this._canvas = document.createElement("canvas");    
              _this._canvas.className = 'pdf-page-canvas'; 
              
              let _row = document.createElement("div");
              _row.className = 'row m-0 p-0'; 

              let _col = document.createElement("div");
              _col.className = 'col m-0 p-0 saop-col-view'; 

              _col.appendChild(_this._canvas); 

              _row.appendChild(_col); 

              _this._viewer.appendChild(_row);
              _this.renderPage(page, _this._canvas);
              
            }

        });        
    }

    getFileNameByUrl(url:string):void {
        let _this = this;
        $.ajax({
            type: "HEAD",
            url: url,         
            success: function(message, text, response){
                _this._type = response.getResponseHeader('Content-Type');
                _this.documentRender();
            },
        });   
    }

    private renderErrorDiv():void{
        //$('#pdf-viewer').html('<div>Ni dokumentov za prikaz</div>');
    }

    documentPreview():void {
        let _this = this;
        this.renderErrorDiv();
        this._documentId = $("#myModel_DocumentId").val() as string;
        this._url = $("#myModel_FileUrl").val() as string;
        this._fileName = $("#myModel_FileName").val() as string;
        this._base64 = $("#myModel_Base64String").val() as string;

        let _w = screen.width;

        if (this._url.length > 0 && this._fileName.length == 0) {
            this.getFileNameByUrl(this._url);
        }

        if (this._base64.length == 0) {return;}

        let _fileExtension = this._fileName.split('.').pop().toLocaleLowerCase();

        if (_fileExtension.length == 0) {return;}

        this._type = "image/png";
        if (_fileExtension.toLocaleLowerCase() == 'pdf'){
            this._type = "application/pdf";
        } else {
            this._type = "image/"+_fileExtension;
        }

        this.documentRender();

    }    

    documentRender():void {
       let _w = screen.width;

        if(_w <= 800 && this._type.includes("pdf") == true){
            //
            this.preparePdfNodes();
            let loadingTask:any;
            if (this._base64.length > 0) {
                let _array = this.base64ToUint8Array(this._base64);
                loadingTask = this._pdfjsLib.getDocument(_array);   
            } else {
                loadingTask = this._pdfjsLib.getDocument(this._url); 
            }
            this.loadingPdfTask(loadingTask);
        } else {
            if (this._base64.length > 0) {
                $('#pdf-viewer').html('<embed Src="data:'+this._type+';base64,'+this._base64+'" class="mx-auto d-flex h-100 w-100" type="'+this._type+'"></embed>');
            } else {
                $('#pdf-viewer').html('<embed Src="'+this._url+'" class="mx-auto d-flex h-100 w-100" type="'+this._type+'""></embed>');        
            }          
        }
    }    

    private preparePdfNodes():void{
        let _parent = $('#pdf-viewer').parent();

        let _main = document.createElement("div");
        _main.className = 'pdf-viewer-main'; 

        let _inner = document.createElement("div");
        _inner.className = 'pdf-viewer-inner';

        let _viewer = document.createElement("div");
        _viewer.id = 'pdf-viewer';            

        _inner.appendChild(_viewer);

        _main.appendChild(_inner);

        _parent.html(_main);  
    }

    // loadBase64Pdf():void{
    //     let _base64 = $("#myModel_Base64String").val() as string;

    //     if (_base64.length > 0) {
    //         let _fileName = $("#myModel_FileName").val() as string;
    //         let _fileExtension = _fileName.split('.').pop().toLocaleLowerCase();
    //         let _w = screen.width;

    //         if(_w <= 800 && _fileExtension.toLocaleLowerCase() == "pdf"){
    //             //
    //             this.preparePdfNodes();
    //             let _array = this.base64ToUint8Array(_base64);
    //             var loadingTask = this._pdfjsLib.getDocument(_array);   
    //             this.loadingPdfTask(loadingTask);
    //         } else {
    //             let _type = "image/png";
    //             if (_fileExtension.toLocaleLowerCase() == 'pdf'){
    //                 _type = "application/pdf";
    //             } else {
    //                 _type = "image/"+_fileExtension;
    //             }

    //             $('#pdf-viewer').html('<embed Src="data:'+_type+';base64,'+_base64+'" class="mx-auto d-flex h-100 w-100" type="'+_type+'"></embed>');
    //         }
    //     }
    // }

    //

}





